export type ReportingData = Readonly<Record<string, string | number | boolean | null>>

export function assertPlainReportingData(data: ReportingData): void {
  for (const [key, value] of Object.entries(data)) {
    if (!key.trim()) throw new Error('Reporting data keys must not be empty')
    if (value !== null && !['string', 'number', 'boolean'].includes(typeof value)) {
      throw new Error(`Reporting data "${key}" must be a string, number, boolean, or null`)
    }
    if (typeof value === 'number' && !Number.isFinite(value)) {
      throw new Error(`Reporting data "${key}" must be a finite number`)
    }
  }
}
